// src/api/UserAPI.js
import API from "./axios";

export const updateUserById = async (id, payload) => {
  try {
    console.log("PAYLOAD : ", payload);
    const response = await API.put(`/updateUserById/${id}`, payload, {
      headers: {
         "Content-Type":
            payload instanceof FormData ? undefined : "application/json",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Failed to update user detail:", error);
    throw error;
  }
};

